import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Workspace from './components/Workspace';
import Landing from './components/Landing';
import Login from './components/Login';
import SignUp from './components/SignUp';
import { AuthProvider, useAuth } from './components/AuthContext';

function PrivateRoute({ children }) {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          {/* Landing page is public */}
          <Route path="/" element={<Landing />} />
          {/* Protected workspace */}
          <Route
            path="/app"
            element={
              <PrivateRoute>
                <Workspace />
              </PrivateRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

